// src/modules/LiberaProximaVenda/index.jsx
import React, { useState } from 'react';
import { MainContainer } from '../../components/template/MainContainer';
import SelectionForm from './SelectionForm';
import DocumentDetail from './DocumentDetail';

export default () => {
  const [selectedDocument, setSelectedDocument] = useState(null);

  const handleDocumentSelect = (documentData) => {
    setSelectedDocument(documentData);
  };

  const handleBack = () => {
    setSelectedDocument(null);
  };

  return (
    <MainContainer headerData={{ title: `Libera Proxima Venda`, subtitle: `Autorização` }}>
      {!selectedDocument ? (
        <SelectionForm onDocumentSelect={handleDocumentSelect} />
      ) : (
        <DocumentDetail documentData={selectedDocument} onBack={handleBack} />
      )}
    </MainContainer>
  );
};
